import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class NewsSwiper {
    constructor() {
        console.log('%c👍🏼 Swiper 2', 'color: yellow');
        
        this.swiperLatestNews = document.querySelectorAll(
            '.swiper--news-swiper'
        )
    }
    init() {
        this.swiperLatestNews.forEach((elem, i) => {
            new Swiper(elem, {
                slidesPerView: 1.5,
                loop: true,
                spaceBetween: 20,
                speed: 1001,
                // autoplay: {
                //     delay: 10000,
                //     disableOnInteraction: true
                // },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    540: {
                    slidesPerView: 2.3
                    },
                    998: {
                    slidesPerView: 2.5
                    },
                }
            });   
        })
    }
}